import { render, staticRenderFns } from "./ChatSupportIcon.vue?vue&type=template&id=7d624240&scoped=true"
import script from "./ChatSupportIcon.vue?vue&type=script&lang=js"
export * from "./ChatSupportIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d624240",
  null
  
)

export default component.exports